export default __webpack_public_path__ + "static/gallery-3-347babc71196198ae1136393c514a7fa.jpg";